<template>
	<div class="list">
		<div class="page">
			<ul class="th">
				<li>{{ $t( 'rehabilitation.equipment' ) }}</li>
				<li>{{ $t( 'patient.condition.paralysis_part' ) }}</li>
				<li>{{ $t( 'rehabilitation.direction' ) }}</li>
				<li>{{ $t( 'report.inquiry_period' ) }}</li>
			</ul>
			<ul class="tr">
				<li>{{ rehabilitationItems.seqDeviceType }}</li>
				<li>{{ rehabilitationItems.position }}</li>
				<li>{{ rehabilitationItems.direction }}</li>
				<li>{{ rehabilitationItems.searchDate }}</li>
			</ul>
		</div>
    <div class="page">
      <ul class="th">
        <li>{{ this.$t( 'patient.measure.first_measurement' ) + '(' + this.$t( 'status.date' ) + ')' }}</li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
		<div class="page">
			<ul class="th">
				<li>{{ rehabilitationItems.initData.aRom.date }}</li>
				<li>{{ rehabilitationItems.initData.pRom.date }}</li>
				<li>{{ rehabilitationItems.initData.MMT.date }}</li>
        <li></li>
			</ul>
			<ul class="tr">
				<li>{{ rehabilitationItems.initData.aRom.value }}</li>
				<li>{{ rehabilitationItems.initData.pRom.value }}</li>
				<li>{{ rehabilitationItems.initData.MMT.value }}</li>
        <li></li>
			</ul>
		</div>
    <div class="page">
      <ul class="th">
        <li>
          {{ this.$t( 'patient.measure.recent_measurement' ) + '(' + this.$t( 'status.date' ) + ')' }}
        </li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
		<div class="page">
			<ul class="th">
				<li>{{ rehabilitationItems.lastData.aRom.date }}</li>
				<li>{{ rehabilitationItems.lastData.pRom.date }}</li>
				<li>{{ rehabilitationItems.lastData.MMT.date }}</li>
        <li></li>
			</ul>
			<ul class="tr">
				<li>{{ rehabilitationItems.lastData.aRom.value }}</li>
				<li>{{ rehabilitationItems.lastData.pRom.value }}</li>
				<li>{{ rehabilitationItems.lastData.MMT.value }}</li>
        <li></li>
			</ul>
		</div>
	</div>
</template>
<script>
import { DEVICE_TYPE_TRANS, DIRECTION_TRANS, MMT_GRADE_TRANS, POSITION_TRANS } from "@/enum/lib";
import { _REHABILITATION_ITEMS_TEMPLATE } from "@/components/modal/reportModal/lib";

export default {
    name: "RehabilitationTable",
    props: [ 'rehabilitationItemsProps' ],
    data() {
        return {
            rehabilitationItems: _REHABILITATION_ITEMS_TEMPLATE,
        }
    },
    methods: {},
    computed: {
        calculateRehabilitationItems() {
            const propsData = this.rehabilitationItemsProps;
            return {
              seqDeviceType: this.$t( DEVICE_TYPE_TRANS[ propsData.seqDeviceType ].trans ),
              position: this.$t( POSITION_TRANS[ propsData.position ].trans ),
              direction: this.$t( DIRECTION_TRANS[ propsData.direction ].trans ),
              searchDate: this.moment( propsData.searchDate.start ).locale(this.$t('country')).format('ll')
                  + ' ~ ' + this.moment( propsData.searchDate.end ).locale(this.$t('country')).format('ll'),
              initData: {
                aRom: {
                  date: this.$t( `unit.aRom.name` )
                      + `(${propsData.initData.aRom.date !== '' ?
                          this.moment( propsData.initData.aRom.date ).locale(this.$t('country')).format('ll') : '-'})`,
                  value: propsData.initData.aRom.value !== null ?
                      propsData.initData.aRom.value + this.$t( 'unit.deg' ) : this.$t( 'statistic.no_data' ) ,
                },
                pRom: {
                  date: this.$t( `unit.pRom.name` )
                      + `(${propsData.initData.pRom.date !== '' ?
                          this.moment( propsData.initData.pRom.date ).locale(this.$t('country')).format('ll') : '-'})`,
                  value: propsData.initData.pRom.value !== null ?
                      propsData.initData.pRom.value + this.$t( 'unit.deg' ) : this.$t( 'statistic.no_data' ) ,
                },
                MMT: {
                  date: this.$t( `unit.MMT.name` )
                      + `(${propsData.initData.MMT.date !== '' ?
                          this.moment( propsData.initData.MMT.date ).locale(this.$t('country')).format('ll') : '-'})`,
                  value: propsData.initData.MMT.value !== null ?
                      this.$t( MMT_GRADE_TRANS[ propsData.initData.MMT.value ].trans ) + ' / 5' : this.$t( 'statistic.no_data' ) ,
                }
              },
              lastData: {
                aRom: {
                  date: this.$t( `unit.aRom.name` )
                      + `(${propsData.lastData.aRom.date !== '' ?
                          this.moment( propsData.lastData.aRom.date ).locale(this.$t('country')).format('ll') : '-'})`,
                  value: propsData.lastData.aRom.value !== null ?
                      propsData.lastData.aRom.value + this.$t( 'unit.deg' ) : this.$t( 'statistic.no_data' ) ,
                },
                pRom: {
                  date: this.$t( `unit.pRom.name` )
                      + `(${propsData.lastData.pRom.date !== '' ?
                          this.moment( propsData.lastData.pRom.date ).locale(this.$t('country')).format('ll') : '-'})`,
                  value: propsData.lastData.pRom.value !== null ?
                      propsData.lastData.pRom.value + this.$t( 'unit.deg' ) : this.$t( 'statistic.no_data' ) ,
                },
                MMT: {
                  date: this.$t( `unit.MMT.name` )
                      + `(${propsData.lastData.MMT.date !== '' ?
                          this.moment( propsData.lastData.MMT.date ).locale(this.$t('country')).format('ll') : '-'})`,
                  value: propsData.lastData.MMT.value !== null ?
                      this.$t( MMT_GRADE_TRANS[ propsData.lastData.MMT.value ].trans ) + ' / 5' : this.$t( 'statistic.no_data' ) ,
                }
              }
            };
        }
    },
    mounted() {
        this.rehabilitationItems = this.calculateRehabilitationItems;
    },
    watch: {
        rehabilitationItemsProps: {
            deep: true,
            handler() {
                this.rehabilitationItems = this.calculateRehabilitationItems;
            }
        }
    }
}
</script>